<template>
    <StateAbstract class="state-empty">

        <span>You have no {{ subject || 'assets' }} yet.</span>
        <v-btn
            class="state-empty__button" 
            color="color1" 
            elevation="0" 
            @click="handleStart">
            Start creating
        </v-btn>

    </StateAbstract>
</template>

<script>
import ROUTES from '@generio-ai/library-legacy/constants/routes'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import StateAbstract from '@/components/common/state/StateAbstract.vue'

export default {
    name: 'StateEmpty',
    components: {
        StateAbstract
    },
    props: {
        subject: {
            type: String,
            default: ''
        }
    },
    methods: {
        ...mapActions('router', [
            'openRoute'
        ]),
        handleStart() {
            this.openRoute({ route: ROUTES.APPSUITE.CREATE })
        }
    }
}
</script>

<style scoped>
.state-empty__button {
    margin-top: 20px;
}
</style>